module.exports = __webpack_public_path__ + "img/SketchPng68ae7aaf186b470ffbac95e3f88b48853e360d9059ee98f2c749e3ed6c3dfe02.3aa4a3fa.png";